"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _application = require("@/services/application.service");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default2 = exports.default = {
  name: 'ModalNewPrescription',
  props: {
    prescription: {
      type: Object,
      default: null
    },
    categorias: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    onSuccess: {
      type: Function,
      default: function _default() {}
    },
    createPrescription: {
      type: Function,
      default: function _default() {}
    },
    updatePrescription: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      form: {
        nome: '',
        descricao: '',
        categoria: '',
        produtos: [{
          produtoId: '',
          dosagem: '',
          tipoAplicacao: '',
          volume: ''
        }]
      },
      produtosDisponiveis: []
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)({
    farm: 'GET_FARM'
  })), {}, {
    isEdit: function isEdit() {
      return !!this.prescription;
    },
    title: function title() {
      return this.isEdit ? 'Editar prescrição' : 'Nova prescrição';
    }
  }),
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _this = this;
      var _this$prescription$pr;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return this.loadProdutosDisponiveis();
          case 1:
            if (this.prescription) {
              this.form.nome = this.prescription.nome || '';
              this.form.descricao = this.prescription.descricao || '';
              this.form.categoria = this.prescription.categoria || '';
              if ((_this$prescription$pr = this.prescription.produtos) !== null && _this$prescription$pr !== void 0 && _this$prescription$pr.length) {
                this.form.produtos = this.prescription.produtos.map(function (p) {
                  return {
                    produtoId: p.productId || p.produtoId || '',
                    dosagem: p.dosage || p.dosagem || '',
                    tipoAplicacao: _this.getApplicationTypeInPortuguese(p.applicationType || p.tipoAplicacao) || '',
                    volume: p.volume || ''
                  };
                });
              }
            }
          case 2:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    loadProdutosDisponiveis: function () {
      var _loadProdutosDisponiveis = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this$farm, response, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              if ((_this$farm = this.farm) !== null && _this$farm !== void 0 && _this$farm.id) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.n = 2;
              return _application.applicationService.fetchProductsDropdown(this.farm.id);
            case 2:
              response = _context2.v;
              this.produtosDisponiveis = response.data || [];
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              this.produtosDisponiveis = [];
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 3]]);
      }));
      function loadProdutosDisponiveis() {
        return _loadProdutosDisponiveis.apply(this, arguments);
      }
      return loadProdutosDisponiveis;
    }(),
    getApplicationTypeInPortuguese: function getApplicationTypeInPortuguese(type) {
      var typeMap = {
        'AREA': 'Area',
        'VOLUME': 'Volume'
      };
      return typeMap[type] || type;
    },
    save: function () {
      var _save = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this2 = this;
        var produtosValidos, produtosComNome, formData, success;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(!this.form.nome || !this.form.categoria)) {
                _context3.n = 1;
                break;
              }
              this.$buefy.toast.open({
                message: 'Preencha todos os campos obrigatórios',
                type: 'is-warning'
              });
              return _context3.a(2);
            case 1:
              produtosValidos = this.form.produtos.filter(function (p) {
                if (!p.produtoId || !p.dosagem) return false;
                if (p.tipoAplicacao === 'Volume' && !p.volume) return false;
                return true;
              });
              if (!(produtosValidos.length === 0)) {
                _context3.n = 2;
                break;
              }
              this.$buefy.toast.open({
                message: 'Adicione pelo menos um produto com dosagem válida',
                type: 'is-warning'
              });
              return _context3.a(2);
            case 2:
              produtosComNome = produtosValidos.map(function (p) {
                var produto = _this2.produtosDisponiveis.find(function (prod) {
                  return prod.id === p.produtoId;
                });
                var payload = {
                  productId: p.produtoId,
                  productName: (produto === null || produto === void 0 ? void 0 : produto.name) || '',
                  dosage: p.dosagem,
                  unit: (produto === null || produto === void 0 ? void 0 : produto.unit) || ''
                };
                if (p.tipoAplicacao === 'Area') {
                  payload.area = 1;
                } else if (p.tipoAplicacao === 'Volume') {
                  payload.volume = parseInt(p.volume) || 0;
                }
                return payload;
              });
              formData = {
                nome: this.form.nome,
                descricao: this.form.descricao,
                categoria: this.form.categoria,
                produtos: produtosComNome
              };
              success = false;
              if (!this.isEdit) {
                _context3.n = 4;
                break;
              }
              _context3.n = 3;
              return this.updatePrescription(formData, this.prescription);
            case 3:
              success = _context3.v;
              _context3.n = 6;
              break;
            case 4:
              _context3.n = 5;
              return this.createPrescription(formData);
            case 5:
              success = _context3.v;
            case 6:
              if (success) {
                this.onSuccess();
                this.cancelModal();
              }
            case 7:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function save() {
        return _save.apply(this, arguments);
      }
      return save;
    }(),
    addProduto: function addProduto() {
      this.form.produtos.push({
        produtoId: '',
        dosagem: '',
        tipoAplicacao: '',
        volume: ''
      });
    },
    removeProduto: function removeProduto(index) {
      if (this.form.produtos.length > 1) {
        this.form.produtos.splice(index, 1);
      }
    },
    cancelModal: function cancelModal() {
      this.$parent.close();
    },
    getProductUnit: function getProductUnit(produto) {
      var selectedProduct = this.produtosDisponiveis.find(function (p) {
        return p.id === produto.produtoId;
      });
      return (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.unit) || '';
    },
    getDosageDescription: function getDosageDescription(produto) {
      var unit = this.getProductUnit(produto);
      if (produto.tipoAplicacao === 'Area') {
        return "".concat(produto.dosagem, " ").concat(unit, " POR HECTARE");
      } else if (produto.tipoAplicacao === 'Volume' && produto.volume) {
        return "".concat(produto.dosagem, " ").concat(unit, " POR ").concat(produto.volume, " LITROS D'\xC1GUA");
      } else if (produto.tipoAplicacao === 'Volume') {
        return 'POR LITRO D\'ÁGUA';
      }
      return '';
    }
  }
};